"use strict";Object.defineProperty(exports, "__esModule", {value: true});var _utils = require('shared/store/utils');
var _helpers = require('shared/actions/helpers');
















const listMessageTemplatesActions = _utils.createAsyncActions('ListMessageTemplates')
const createMessageTemplateActions = _utils.createAsyncActions('CreateMessageTemplate')
const updateMessageTemplateActions = _utils.createAsyncActions('UpdateMessageTemplate')
const deleteMessageTemplateActions = _utils.createAsyncActions('DeleteMessageTemplate')
const listDeletedMessageTemplatesActions = _utils.createAsyncActions('ListDeletedMessageTemplates')
const restoreMessageTemplateActions = _utils.createAsyncActions('RestoreMessageTemplate')
const getMessageTemplateActions = _utils.createAsyncActions('GetMessageTemplate')
const suggestTemplateBlanksActions = _utils.createAsyncActions('SuggestTemplateBlanks')

 const actionCreators = {
  listMessageTemplatesActions,
  createMessageTemplateActions,
  updateMessageTemplateActions,
  deleteMessageTemplateActions,
  listDeletedMessageTemplatesActions,
  restoreMessageTemplateActions,
  getMessageTemplateActions,
  suggestTemplateBlanksActions,
}; exports.actionCreators = actionCreators

/* Loads the org's templates the signed-in user can see. The picker calls it
 * each time it opens, so teammates' edits show up then (no live push). */
const listMessageTemplates = (OrgKey) =>
  _helpers.wsCommand('ListMessageTemplates', listMessageTemplatesActions, { OrgKey }, { OrgKey })

const createMessageTemplate = (OrgKey, { Scope, TeamKey, Name, Body }) =>
  _helpers.wsCommand(
    'CreateMessageTemplate',
    createMessageTemplateActions,
    { OrgKey, Scope, ...(Scope === 'team' ? { TeamKey } : {}), Name, Body },
    null,
  )

/* KnownUpdatedAt is the UpdatedAt of the version the editor opened. If the
 * save is refused (someone changed it since), the list reloads so the
 * template reopens as it is now. */
const updateMessageTemplate = (
  OrgKey,
  TemplateKey,
  { Scope, TeamKey, Name, Body },
  KnownUpdatedAt,
) => _helpers.wsCommand(
  'UpdateMessageTemplate',
  updateMessageTemplateActions,
  { OrgKey, TemplateKey, Scope, ...(Scope === 'team' ? { TeamKey } : {}), Name, Body, ...(KnownUpdatedAt ? { KnownUpdatedAt } : {}) },
  null,
).catch((e) => {
  listMessageTemplates(OrgKey).catch(() => null)
  throw e
})

const deleteMessageTemplate = (OrgKey, TemplateKey) =>
  _helpers.wsCommand(
    'DeleteMessageTemplate',
    deleteMessageTemplateActions,
    { OrgKey, TemplateKey },
    { OrgKey, TemplateKey },
  )

/* Templates deleted in the last 30 days that the signed-in user could
 * restore. Not kept in the store: the Settings page shows them while open. */
const listDeletedMessageTemplates = (OrgKey) =>
  _helpers.wsCommand('ListDeletedMessageTemplates', listDeletedMessageTemplatesActions, { OrgKey }, { OrgKey })

/* Undoes a delete; the template comes back with its key, scope and text. */
const restoreMessageTemplate = (OrgKey, TemplateKey) =>
  _helpers.wsCommand(
    'RestoreMessageTemplate',
    restoreMessageTemplateActions,
    { OrgKey, TemplateKey },
    null,
  )

/* One template's latest version (or Deleted), into the store. */
const getMessageTemplate = (OrgKey, TemplateKey, KnownUpdatedAt) =>
  _helpers.wsCommand('GetMessageTemplate', getMessageTemplateActions, { OrgKey, TemplateKey }, { OrgKey, TemplateKey, KnownUpdatedAt })

/* The details in Text that look patient-specific, found on the server with
 * the chat's patients' names. */
const suggestTemplateBlanks = (OrgKey, ConversationKey, Text) =>
  _helpers.wsCommand('SuggestTemplateBlanks', suggestTemplateBlanksActions, { OrgKey, ConversationKey, Text }, null)

exports. default = {
  getMessageTemplate,
  suggestTemplateBlanks,
  listMessageTemplates,
  createMessageTemplate,
  updateMessageTemplate,
  deleteMessageTemplate,
  listDeletedMessageTemplates,
  restoreMessageTemplate,
}
